export function isDefined<T extends {}>(val: T | null | undefined): val is T {
  const yes = (_: T) => true;
  const no = (_: null | undefined) => false;

  return val !== null && val !== undefined ? yes(val) : no(val);
}
